module.exports = __webpack_public_path__ + "img/INES.c7766f7b.jpeg";